import { getMany, set } from 'idb-keyval'
import { DateTime } from 'luxon'

const LAST_CONNECTED_KEY = 'soketi_last_connected'
const LAST_DISCONNECTED_KEY = 'soketi_last_disconnected'

/**
 * Gets the timestamps when the websocket was last connected and disconnected
 */
export async function getLastConnectedAndDisconnected(): Promise<{
  lastConnected: DateTime | null
  lastDisconnected: DateTime | null
}> {
  const [lastConnectedTimestamp, lastDisconnectedTimestamp] = await getMany<
    string | undefined
  >([LAST_CONNECTED_KEY, LAST_DISCONNECTED_KEY])
  return {
    lastConnected: lastConnectedTimestamp
      ? DateTime.fromISO(lastConnectedTimestamp)
      : null,
    lastDisconnected: lastDisconnectedTimestamp
      ? DateTime.fromISO(lastDisconnectedTimestamp)
      : null,
  }
}

/**
 * Records the current time as the last time the websocket connected
 */
export async function setLastConnected(date: DateTime): Promise<void> {
  await set(LAST_CONNECTED_KEY, date.toISO())
}

/**
 * Records the current time as the last time the websocket disconnected
 */
export async function setLastDisconnected(date: DateTime): Promise<void> {
  await set(LAST_DISCONNECTED_KEY, date.toISO())
}
